export default function modal() {
    const openModalBtns = document.querySelectorAll('[data-modal-target]');
    const body = document.body;

    const overlay = document.createElement('div');
    overlay.classList.add('modal-overlay');
    document.body.appendChild(overlay);

    openModalBtns.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            const targetId = btn.dataset.modalTarget;
            const modal = document.getElementById(targetId);
            if (!modal) return;

            modal.classList.add('active');
            overlay.classList.add('active');
            body.classList.add('modal-open');
        });
    });

    document.addEventListener('click', e => {
        if (e.target.matches('[data-modal-close]')) {
            const modal = e.target.closest('.modal');
            closeModal(modal);
        }
    });

    overlay.addEventListener('click', () => {
        const activeModal = document.querySelector('.modal.active');
        if (activeModal) closeModal(activeModal);
    });

    function closeModal(modal) {
        modal.classList.remove('active');
        overlay.classList.remove('active');
        body.classList.remove('modal-open');
    }
}
